/* eslint-disable no-param-reassign */
function resultHeader(el, totalHits) {
	if (el.reset === true) {
		el.showFirstHeaderInfo = true;
	}

	switch (el.settings.searchType) {
	case 'knowledge':
		el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		break;
	case 'news':
		if (el.showFirstHeaderInfo !== true) {
			el.headerString = '';
			el.showFirstHeaderInfo = true;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'reports':
		if (el.showFirstHeaderInfo === true) {
			el.headerString = el.settings.headerStringThree + ' (' + totalHits + ')';
			el.showFirstHeaderInfo = false;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'publications':
		if (el.showFirstHeaderInfo === true) {
			el.headerString = el.settings.headerStringThree + ' (' + totalHits + ')';
			el.showFirstHeaderInfo = false;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}

		break;
	case 'puljer':
		if (el.showFirstHeaderInfo !== true) {
			el.headerString = '';
			el.showFirstHeaderInfo = true;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'opgaver':
		if (el.showFirstHeaderInfo !== true) {
			el.headerString = '';
			el.showFirstHeaderInfo = true;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'habilitet':
		if (el.showFirstHeaderInfo === true) {
			el.headerString = el.settings.headerStringThree + ' (' + totalHits + ')';
			el.showFirstHeaderInfo = false;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'fou':
		if (el.showFirstHeaderInfo === true) {
			el.headerString = el.settings.headerStringThree + ' (' + totalHits + ')';
			el.showFirstHeaderInfo = false;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		break;
	case 'fou-search-global':
		if (el.showFirstHeaderInfo === true) {
			el.headerString = el.settings.headerStringThree + ' (' + totalHits + ')';
			el.showFirstHeaderInfo = false;
		} else {
			el.headerString = el.settings.headerStringOne + ' ' + +totalHits + ' ' + el.settings.headerStringTwo;
		}
		
		// Update string with filters
		if (el.selectBoxValues.length > 0) {
			const withCategory2 = el.selectBoxValues[1] ? ' ' + el.settings.category2 + ' ' + el.selectBoxValues[1] : ' ';
			el.headerString = el.headerString + ' ' + el.settings.category1	+ ' ' + el.selectBoxValues[0] + withCategory2;
		}
		break;
	default:
		break;
	}

	const headingTag = document.querySelector('.js-search-list-header');

	if (el.headerString.length > 0) {
		headingTag.innerHTML = el.headerString;
	}

	headingTag.ariaHidden = el.headerString.length === 0;
}

export default resultHeader;
